import axios from 'axios';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      cards: {},
      banners: {},
      __updatedAt: {},
    },
    mutations: {
      SET_CARDS(state, { data, locale }) {
        state.cards = {
          ...state.cards,
          [locale]: data,
        }
        state.__updatedAt[locale] = Date.now();
      },
      SET_BANNERS(state, { data, locale}) {
        state.banners = {
          ...state.banners,
          [locale]: data,
        }
        state.__updatedAt[locale] = Date.now();
      },
    },
    actions: {
      FETCH_WHATSHAPPENING({ state, commit }, { locale }) {
        if (state.cards[locale]
          && state.banners[locale]
          && state.__updatedAt[locale]
          && Date.now() - state.__updatedAt[locale] < cachetime 
        ) return ;
        return axios.get(encodeURI(`/api/whatshappening`))
          .then((res) => {
            const data = res.data || {};
            const { cards=[], banners=[] } = data;

            commit('SET_CARDS', { data: cards, locale });
            commit('SET_BANNERS', { data: banners, locale });
          }).catch(err => console.log(err));      
      },
    },
    getters: { 
      getCards: (state) => (locale) => {
        return state.cards[locale] || [];
      },
      getBanners: (state) => (locale) => {
        return state.banners[locale] || [];
      }
    }
  }
}